export default __webpack_public_path__ + "static/media/benefit-directory.80c745f9.png";